import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-chemistregreset',
    template: require('./chemistregreset.component.html'),
    styles: []
})
export class chemistregresetComponent implements OnInit {

    expDetails: any=[];
    private columnDefs;
    private rowData;
    private rowHeight;
    api: GridApi;
    columnApi: ColumnApi;
    defaultColDefine;
    private gridColumnApi;
    private detailCellRendererParams;
    currentMonth: any;
    busy: Subscription;
    staffTypes: any;
    staff: any;
    designation: any;
    currentDate: any;
    userId: any = 0;
    clientType: any = 0;
    date: any = null;
    RouteData: any = [];
    chemistId: any = [];
    token:any;

    static parameters = [ApiService, ToastrService]
    rowSelectionMultiple: string;
    constructor(private apiService: ApiService, private router: Router, private toastr: ToastrService) {
        let parent = this;
        this.columnDefs = [
            { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
            { headerName: '', field: 'action', width: 150, checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true },
            { headerName: 'Chemist Name', field: 'ChemistName', filter: 'agTextColumnFilter' },
            { headerName: 'Employee Name', field: "EmployeeName", filter: 'agTextColumnFilter' },
            { headerName: 'Route Name', field: "RouteName", filter: 'agTextColumnFilter' },
            { headerName: 'Address', field: "AddressLine", filter: 'agTextColumnFilter' },
        ];
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    AutoSizeAlll() {
        // this.gridColumnApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }

    onFirstDataRendered(params) {
        setTimeout(function () {
            params.api.getDisplayedRowAtIndex(1).setExpanded(false);
        }, 0);
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.rowSelectionMultiple = 'multiple';
        // this.getStaffTypes();
        this.getExpDetails();
        $('#filter-option').trigger('click');
    }


    getChemistForReset() {

        let data = { userId: this.userId, routeId: this.clientType,LoginId:this.token.id };
            console.log(data);
        this.busy = this.apiService.getChemistForReset(data).subscribe((res: any) => {
            this.RouteData = res.data;
            setTimeout(() => {
                this.AutoSizeAlll();
            }, 200);
        })
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }

    getRoute() {
        console.log(this.userId)

        this.apiService.getRouteList(this.userId).subscribe((res: any) => {
            this.staffTypes = res.data;
            console.log('stafftypes ', this.staffTypes);
        })
    }

    getExpDetails() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            Id: token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            res.data.filter(data => {
                if (data.EmpActive == '1') {
                    this.expDetails.push(data);
                }
              })
           // console.log('empDetails', this.expDetails);
        })
    }

    reset() {
        this.chemistId = [];
        this.chemistId = this.api.getSelectedRows();
        if (this.chemistId.length == 0) {
            alert("Please Select Chemist For Registration Reset");
            return false;
        }
        var chemistId = this.chemistId.map(item => item.chemistId).toString();
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.busy = this.apiService.resetChemist({ data: chemistId, Id: token.clientId }).subscribe((res: any) => {
            alert("Registration Reset Successfully");
            this.getChemistForReset();
            this.chemistId = []
        })
    }
}
